import React from 'react';
import { useZitoneoUI } from '../../contexts/ZitoneoUIContext';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';

const SidebarContainer = ({ children }: { children: React.ReactNode }) => {
    const { isLoading } = useZitoneoUI();

    return (
        <div className='service-editor__sidebar'>
            {isLoading ? (
                <LoadingPlaceholder
                    variant='rounded'
                    width={360}
                    height={600}
                />
            ) : (
                children
            )}
        </div>
    );
};

export default SidebarContainer;
